import React, { useEffect, useRef, useState } from "react";
import SuggestionList from "../Offline/ProductLists/SuggestionList";
import { getExternalOrderSearchSuggestions } from "../../../utils/apis/orders/externalOrderSearch";

let debounceTimer;

const ExternalOrderSearchInput = ({ value, onChange, onSelect }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchSuggestions = (term) => {
    clearTimeout(debounceTimer);
    if (!term || !term.trim()) {
      setSuggestions([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    debounceTimer = setTimeout(async () => {
      try {
        const results = await getExternalOrderSearchSuggestions(term);
        setSuggestions(results);
      } catch (error) {
        console.error("External order search error:", error);
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    }, 300);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);
    setShowDropdown(true);
    setHighlightedIndex(-1);
    fetchSuggestions(val);
  };

  const handleSelect = (item) => {
    onChange(item.name);
    setShowDropdown(false);
    setSuggestions([]);
    onSelect?.(item);
  };

  const handleKeyDown = (e) => {
    if (!showDropdown || suggestions.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
        e.preventDefault();
        handleSelect(suggestions[highlightedIndex]);
      }
    } else if (e.key === "Escape") {
      setShowDropdown(false);
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <input
        type="text"
        className="form-control"
        value={value}
        placeholder="Search Name, Contact No, Product"
        onChange={handleChange}
        onFocus={() => value && setShowDropdown(true)}
        onKeyDown={handleKeyDown}
      />
      {showDropdown && value && (
        <div
          className="external-order-search-suggestions-wrapper"
          style={{ position: "absolute", zIndex: 30, minWidth: "280px" }}
        >
          <style>{`
            .external-order-search-suggestions-wrapper .smart-search-suggestions-list {
              max-height: 220px !important;
            }
          `}</style>
          <SuggestionList
            suggestions={suggestions}
            loading={loading}
            keyword={value}
            highlightedIndex={highlightedIndex}
            onHover={setHighlightedIndex}
            onSelect={handleSelect}
          />
        </div>
      )}
    </div>
  );
};

export default ExternalOrderSearchInput;